import React from 'react';
import { connect } from 'react-redux';
import {
  loadIpmaCisCreator,
  setIpmaCisPageCreator,
  setIpmaCisPerPageCreator,
  setIpmaCisSortCreator,
  setIpmaCisFiltersCreator,
  removeIpmaCisFiltersCreator,
  loadGlobalCisCertificatesAttributesCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import CertificateHolders from '../../../../shared/Cis/CertificateHolders/CertificateHolders';

const mapStateToProps = ({ loading, ipma, globals }) => ({
  loading: isLoading(loading, 'LOAD_IPMA_CIS'),
  type: 'ipma-cvmb',
  list: ipma.cis.certificateHolders,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadIpmaCisCreator('certificateHolders')),
  setPage: (payload) => dispatch(setIpmaCisPageCreator('certificateHolders', payload)),
  setPerPage: (payload) => dispatch(setIpmaCisPerPageCreator('certificateHolders', payload)),
  setSort: (payload) => dispatch(setIpmaCisSortCreator('certificateHolders', payload)),
  setFilters: (payload) => dispatch(setIpmaCisFiltersCreator('certificateHolders', payload)),
  removeFilters: () => dispatch(removeIpmaCisFiltersCreator('certificateHolders')),
  loadCertificateHoldersAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CertificateHolders); 